import { LandingData } from "../core/buildLandingData";

export const DEFAULT_THEME: LandingData["theme"] = {
  backgroundType: "image",
  backgroundImage: "",
  backgroundColor: "#000000",

  globalStyles: {
    fontFamily: "Inter",

    h1Color: "#ffffff",
    h2Color: "#ffffff",
    h3Color: "#ffffff",

    textColor: "#a1a1aa",

    buttonColor: "#00f4fb",
    buttonTextColor: "#000000",

    accentColor: "#00f4fb",
  },

  components: {}, // obligatorio por el tipo
};